/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/bread-crumb/bread-crumb');

const asideLayout = require('../aside-layout/aside-layout');
const headerLayout = require('../header-layout/header-layout');

const { apiPath } = require('appService/api');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const { getPageUrl } = require('src/common/utils/utils');
const {getCookie, addCookie, delCookie} = require('src/common/utils/cookie');
const { setCityList, setTopicList, setBrandList } = require('appVuex/action/common')

const tip = require('components/base/pop/tip');
const ajaxHttp = require('appUtil/ajaxHttp');
const store = require('appVuex/store');

require('./page-layout.scss');
const template = require('./page-layout.tpl');

module.exports = {
  name: "page-layout",

  template,

  data(){
  	return {
      toggleFlag: false,
      menus: [],
      breadCrumbData: {},
      pageBtnList: {},
      hasValidateBtnList: true,
      routerInfo: null
  	}
  },

  components: {
    "aside-layout": asideLayout,
    "header-layout": headerLayout
  },

  vuex: {
    actions: {
      setBreadCrumb,
      setCityList,
      setTopicList,
      setBrandList
    }
  },
  watch: {
    btnArr(val, oldVal){
      if (this.routerInfo) {
        this.loadBtn(this.routerInfo);
      }
    }
  },
  store,

  route: {
    data(transition) {
      COMMON.componentHub.breadCrumb = [];
      this.loadMenu(transition);
      this.loadBtn(transition);
      this.$broadcast('initScroll');
      transition.next();
    },
    waitForData: true
  },

  methods: {
  	loadMenu(transition) {
      ajaxHttp(apiPath.aside.menu, {}).then((res)=>{
        if (res.data.length !== 0) {
          this.menus = res.data[0].secondMenus;
          this.breadCrumbData = {
            data: res.data[0].secondMenus,
            path: transition.to.path
          }
        } else {
          this.$router.go({
            path: "/403"
          });
        }
      })
      .catch((res)=> {
        console.log(res)
        // tip(res.error);
      });
    },
    loadBtn(transition) {
      // @todo 页面按钮在此权限控制
      // getPageUrl(transition);
      let data = {
        url: getPageUrl(transition)
      };

      //生成全局按钮
      let setBtn = (list) => {
        if (!list) {
          return false;
        }

        let o = {}

        for (let i = 0; i < list.length; i++) {
          let o = list[i];
          o[o.btnId] = true;
        }

        return o;
      };

      ajaxHttp(apiPath.login.pageBtnIdList, {
        data: data
      }).then((res)=> {
        let o = setBtn(res.data);
        this.$broadcast('setBtn', o);
        this.setAuthorityBtn(o);
        this.$set('pageBtnList', o);
        this.validateBtn(o);
      }).catch((res)=> {
        return false
      });
    },
    validateBtn(data) {
      data = data ? data : this.pageBtnList;
      this.btnArr.forEach((item) => {
        let flag = item.flag;
        let pageBtnList = data;
        if (flag) {
          //当匹配按钮数据为空，则页面按钮隐藏
          if (isEmpty(pageBtnList) || !(flag in pageBtnList)) {
            if(item.textDisplay){
              item.btnValueDisplay = true;
            } else {
              item.show = false;
            }
          } else if(flag in pageBtnList) {
            item.show = true;
          }
        }
      })
    },
    getCommonData() {
      ajaxHttp(apiPath.common.city).then((rtn) => {
        this.setCityList(rtn.data)
      }).catch(() => {
        return false
      })

      ajaxHttp(apiPath.common.topic).then((rtn) => {
        this.setTopicList(rtn.data)
      }).catch(() => {
        return false
      })

      ajaxHttp(apiPath.common.carBrand).then((rtn) => {
        this.setBrandList(rtn.data)
      }).catch(() => {
        return false
      })
    }
  },

  ready(){
    var pageHeight = document.documentElement.clientHeight;
    $(this.$el).css({ "min-height": pageHeight });

    this.getCommonData()
  },
  events: {
    toggle(val){
      this.toggleFlag = val
      this.$broadcast('toggle', this.toggleFlag)
    }
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/components/layout/page-layout/page-layout.js